// libs
import React, { memo, useCallback, useState } from 'react';

// components
import Collapsible from 'shared/components/Collapsible';
import CollapsibleHeader from 'shared/layouts/DetailsPage/components/ProductInfo/components/CollapsibleHeader';
import CollapsibleExpander from 'shared/layouts/DetailsPage/components/ProductInfo/components/CollapsibleHeader/CollapsibleExpander';
import CollapsibleContent from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductDescription/components/CollapsibleContent';
import { IWidget } from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductDescription/types';

interface IDescriptionRow {
  widget: IWidget;
}
function DescriptionRow({ widget }: IDescriptionRow) {
  const [isExpanded, setIsExpanded] = useState(false);

  const onChange = useCallback((expanded: boolean) => {
    setIsExpanded(expanded);
  }, []);

  return (
    <Collapsible
      className="collapsible"
      CustomExpander={CollapsibleExpander}
      header={
        <CollapsibleHeader
          title={widget.title}
          subtitle={widget.subtitle ? widget.subtitle : ''}
          isExpanded={isExpanded}
          iconName={widget.iconName ? widget.iconName : ''}
        />
      }
      onChange={onChange}
    >
      <CollapsibleContent widget={widget}></CollapsibleContent>
    </Collapsible>
  );
}

export default memo(DescriptionRow);
